var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading
        ? [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("p", [
                        _vm._v("Заявка: "),
                        _c("strong", [_vm._v(_vm._s(_vm.order.id))]),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("Клиент: "),
                        _c("strong", [_vm._v(_vm._s(_vm.order.client_name))]),
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v("Телефоны:")]),
                      _vm._v(" "),
                      _vm._l(_vm.order.order_phones, function (p) {
                        return _c("p", [
                          _c(
                            "a",
                            { attrs: { href: `tel:+${p.phone.phone}` } },
                            [_vm._v(_vm._s(p.phone.phone))]
                          ),
                        ])
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("Дата доставки: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.printDate(
                                _vm.order.delivery_date,
                                "DD.MM.YYYY"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v("Адрес: " + _vm._s(_vm.order.address))]),
                      _vm._v(" "),
                      _c("RunnerSalaryRate", {
                        attrs: {
                          rate: _vm.order?.extra_options?.salary_rate ?? 0,
                        },
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "table",
                      { staticClass: "table table-sm mt-0 table-style-1" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.order.details, function (d) {
                              return _c("tr", [
                                _c("td", [_vm._v(_vm._s(d.drug.title))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(d.qty))]),
                              ])
                            }),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v("доставка:")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.order.delivery_price ?? 0)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v("итого:")]),
                              _vm._v(" "),
                              _c("td", [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.order.price ?? 0)),
                                ]),
                              ]),
                            ]),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      (_vm.phoneCalls ?? []).length
                        ? [
                            _c("p", [
                              _vm._v("Всего звонков: "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.phoneCalls.length)),
                              ]),
                            ]),
                            _vm._v(" "),
                            !_vm.showPhoneCalls
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-xs btn-outline-info",
                                    on: {
                                      click: function ($event) {
                                        _vm.showPhoneCalls = !_vm.showPhoneCalls
                                      },
                                    },
                                  },
                                  [_vm._v("Показать звонки\n              ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showPhoneCalls
                              ? _c(
                                  "div",
                                  { staticClass: "mb-1" },
                                  _vm._l(_vm.phoneCalls, function (call) {
                                    return _c("div", [
                                      _c("p", { staticClass: "fs-12" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.printDate(
                                              call.created_at,
                                              "DD.MM.YYYY HH:mm"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      call.file_link
                                        ? _c(
                                            "audio",
                                            { attrs: { controls: "" } },
                                            [
                                              _c("source", {
                                                attrs: {
                                                  src: `/api/noa/mangoRecord/${call.id}`,
                                                  type: "audio/mpeg",
                                                },
                                              }),
                                              _vm._v(
                                                "\n                    Your browser does not support the audio tag.\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  }),
                                  0
                                )
                              : _vm._e(),
                          ]
                        : [
                            _c("p", [
                              _vm._v("Нет звонков в системе по этому номеру"),
                            ]),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-8" },
                    [
                      (_vm.historyOrders ?? []).length
                        ? [
                            _c(
                              "table",
                              { staticClass: "table table-style-1 mt-0" },
                              [
                                _c(
                                  "tbody",
                                  _vm._l(_vm.historyOrders, function (o) {
                                    return _c("tr", [
                                      _c(
                                        "td",
                                        _vm._l(o.details, function (d) {
                                          return _c("p", [
                                            _vm._v(_vm._s(d.drug.title)),
                                          ])
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _c("OrderStatus", {
                                            attrs: { status: o.status },
                                          }),
                                          _vm._v(" "),
                                          o.reject_comment
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "fs-12 text-muted",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(o.reject_comment)
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c("span", { staticClass: "fs-12" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.printDate(
                                                o.created_at,
                                                "DD.MM.YYYY"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ])
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n              Заявок по этому номеру телефона не найдены\n            "
                            ),
                          ],
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("кол")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("История")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }